import * as IdbKeyVal from "idb-keyval";
import { endOfDay } from 'date-fns'

export class VersionInfo {
    //counter is the number of times the version has been checked today 
    constructor (public dateUpdated: Date, public counter: number, public nextUrl: string) {}
}

export const needNewVersion = async () => {
    const versionInfo = await getVersionInfo();
    var needNewVersion = true;

    let oldDate = endOfDay(versionInfo.dateUpdated);
    let currentDate = endOfDay(new Date());

    return oldDate < currentDate;
}

export const setVersionInfo = async (version: VersionInfo) => {
    await IdbKeyVal.set('versionInfo', version);
}

export const getVersionInfo = async () => {
    let version = await IdbKeyVal.get('versionInfo');
    if (!version){
        version = new VersionInfo(new Date(Date.now() - ( 3600 * 1000 * 24)), 0, "");
    }
    return version;
}

